import api from "./api";
import { API_ENDPOINTS } from "./endpoints";
import {
  Blog,
  BlogFormValues,
  Category,
  CategoryFormValues,
} from "../types/blog";
import { ListResponse, Params } from "../types";

const blogService = {
  async getBlogList(params: Params): Promise<ListResponse<Blog>> {
    try {
      const response = await api.get(API_ENDPOINTS.BLOGS.LIST, { params });
      return response.data;
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },

  async getBlogById(id: number): Promise<Blog> {
    try {
      const response = await api.get(API_ENDPOINTS.BLOGS.GET_BY_ID(id));
      return response.data.data;
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },

  async createBlog(body: BlogFormValues): Promise<void> {
    try {
      await api.post(API_ENDPOINTS.BLOGS.CREATE, body);
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },

  async updateBlog(id: number, body: BlogFormValues): Promise<void> {
    try {
      await api.patch(API_ENDPOINTS.BLOGS.UPDATE(id), body);
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },

  async deleteBlog(id: number): Promise<void> {
    try {
      await api.delete(API_ENDPOINTS.BLOGS.DELETE(id));
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },

  async getCategories(params: Params): Promise<ListResponse<Category>> {
    try {
      const response = await api.get(API_ENDPOINTS.CATEGORIES.LIST, { params });
      return response.data;
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },

  async createCategory(body: CategoryFormValues): Promise<void> {
    try {
      await api.post(API_ENDPOINTS.CATEGORIES.CREATE, body);
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },

  async updateCategory(id: number, body: CategoryFormValues): Promise<void> {
    try {
      await api.patch(API_ENDPOINTS.CATEGORIES.UPDATE(id), body);
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },

  async deleteCategory(id: number): Promise<void> {
    try {
      await api.delete(API_ENDPOINTS.CATEGORIES.DELETE(id));
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },

  async uploadImage(body: FormData): Promise<string> {
    try {
      const response = await api.post(API_ENDPOINTS.FILES.UPLOAD, body, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data.data.fileUrl;
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },
};

export default blogService;
